import axios from "axios";
import { useEffect } from "react";
import { useCookies } from "react-cookie";

const axiosSecure = axios.create({
  baseURL: process.env.REACT_APP_AXIOS_BASE_URL,
  credentials: "include",
});

const useAxiosSecure = () => {
  const [cookies] = useCookies(["accessToken"]);
  useEffect(() => {
    axiosSecure.interceptors.request.use((config) => {
      const token = cookies["accessToken"];
      if (token) {
        config.headers.authorization = `Bearer ${token}`;
      }
      return config;
    });
  }, [cookies]);

  return { axiosSecure };
};

export default useAxiosSecure;
